import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const isLogin = localStorage.getItem('vendor_super_token');
  
  return isLogin ? children : <Navigate to="/" />;
};

export default PrivateRoute; 